import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { deleteArea, updateArea } from "store/actions";
import CreateArea from "./CreateArea";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import TableContainer from "components/Common/DataTableContainer";

import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const AreaTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId, setDeleteId] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const permissions = JSON.parse(localStorage?.getItem("permissions"));

  const handleDelete = (areaId) => {
    dispatch(deleteArea(areaId));
    setDeleteId("");
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: "Area Name",
        accessorKey: "areaName",
        enableSorting: true,
        cell: ({ row }) => <span>{row.original.areaName}</span>,
      },
      {
        header: "Zone",
        accessorKey: "zoneName", // assuming API returns zoneName
        enableSorting: true,
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => {
          const handleEdit = () => {
            setEditData(row.original);
            setIsOpen(true);
          };

          const handleDeleteClick = () => {
            setDeleteId(row.original.areaId);
            setOpenModal(true);
          };

          return (
            <div className="d-flex gap-2">
              {permissions
                ?.map((item) => item?.permissionName)
                ?.includes("Edit Area") && (
                <Button color="primary" onClick={handleEdit} className="mr-2">
                  <FaRegEdit size={18} />
                </Button>
              )}
              {permissions
                ?.map((item) => item?.permissionName)
                ?.includes("Delete Area") && (
                <Button
                  color="danger"
                  onClick={handleDeleteClick}
                  className="mr-2"
                >
                  <MdDeleteOutline size={18} />
                </Button>
              )}
            </div>
          );
        },
      },
    ],
    [permissions]
  );

  const handleSubmit = (data) => {
    dispatch(updateArea(data));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  document.title = "Area Management | Admin Dashboard";

  return (
    <>
      {/* Confirmation Modal for Delete */}
      <ConfirmationModal
        okText="Confirm"
        onCancel={() => {
          setDeleteId("");
          setOpenModal(false);
        }}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Area"
        content="Are you sure you want to delete this area?"
      />

      {/* Create/Edit Area Modal */}
      <CreateArea
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="container-fluid">
        <TableContainer
          loading={loading}
          columns={columns}
          data={List || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search..."
          pagination="pagination"
          docName="Areas"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default AreaTable;
